export default __webpack_public_path__ + "static/media/home.564464e6.svg";